import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../../defaultTheme";
export var StyledTableBody = styled(function (_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataTest = _ref.dataTest;
  return React.createElement("tbody", {
    className: className,
    "data-test": dataTest
  }, children);
}).withConfig({
  displayName: "TableBody__StyledTableBody",
  componentId: "sc-1uovf8k-0"
})(["width:100%;white-space:nowrap;border-left:1px solid ", ";border-right:1px solid ", ";border-bottom:1px solid ", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.borderColorTable;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.borderColorTable;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.borderColorTable;
});
StyledTableBody.defaultProps = {
  theme: defaultTheme
};

var TableBody = function TableBody(_ref5) {
  var children = _ref5.children,
      dataTest = _ref5.dataTest;
  return React.createElement(StyledTableBody, {
    dataTest: dataTest
  }, children);
};

export default TableBody;